const BASEPATH =
  typeof window !== "undefined"
    ? `${
        process.env.REACT_APP_BACKEND_HOST ||
        `${window.location.protocol}//${window.location.hostname}/api`
      }`
    : `${process.env.REACT_APP_BACKEND_HOST}`;

const PUBLIC_BASEPATH = `${BASEPATH.split("/api")[0]}/build/api`;
const PYTHON_BASEPATH = `${process.env.REACT_APP_PYTHON_HOST}`;
const APIS = {
  ACCEPTANCE_STATUS: `${BASEPATH}/shared/documents`,
  ACCESS_CONTROLS: `${BASEPATH}/access_controls`,
  ACCOUNTS_V2: `${BASEPATH}/v2/accounts`,
  ACCOUNTS: `${BASEPATH}/accounts`,
  ACTIVITIES: `${BASEPATH}/object-activities/objects`,
  APP_VIEW_CONFIG: `${BASEPATH}/app`,
  APPROVALS: `${BASEPATH}/approvals`,
  ASSET_BATCH_SHARING: `${BASEPATH}/asset-sharing-batch`,
  ASSET_FOLDER_SEARCH: `${BASEPATH}/folders/search`,
  ASSET_FOLDER: `${BASEPATH}/folders`,
  ASSET_MY_DOCUMENTS: `${BASEPATH}/my-documents`,
  ASSET_SEARCH_SUGGESTION: `${BASEPATH}/folders/suggest`,
  ASSET_SHARING: `${BASEPATH}/asset-sharing`,
  ASSET_STATUS_LIST: `${BASEPATH}/doc-statuses`,
  ASSET_TAGS_LIST: `${BASEPATH}/doc-tags`,
  ASSETS: `${BASEPATH}/assets`,
  ATTACHMENTS_MASTER_DOC: `${BASEPATH}/attachments/master/DOC`,
  AUTH_V2: `${BASEPATH}/v2/auth`,
  AUTH: `${BASEPATH}/auth`,
  AUTOSIGN_CONSENT: `${BASEPATH}/autosign-consent`,
  AUTOSIGN_USERS: `${BASEPATH}/autosign-users`,
  BATCH_UPDATE_TEMPLATE: `${BASEPATH}/docstemplate`,
  BILLING_INFO: `${BASEPATH}/billing/org/billingInfo`,
  BILLING_INVOICE: `${BASEPATH}/billing/invoices`,
  BOX_AUTH: `https://account.box.com/api/oauth2/authorize?response_type=code`,
  BULK_DOC_CREATION: `${BASEPATH}/docs/json-bulk-create`,
  BUNDELS: `${BASEPATH}/bundles`,
  CANCLE_ESIGNATURE: `${BASEPATH}/esign/documents`,
  CATALOGS: `${BASEPATH}/catalogs`,
  CATEGORIES: `${BASEPATH}/categories`,
  CHARGEBEE_CHECKOUT_URL: `${BASEPATH}/billing/org/checkoutlink`,
  CHARGEBEE_PAYMENT_URL: `${BASEPATH}/billing/org/payment`,
  CHILD_VIEWS: `${BASEPATH}/cviews`,
  CLAUSE_ANALYSIS_META: `${BASEPATH}/revvai/clause-analysis/meta`,
  CLAUSE_OPTIONS: `${BASEPATH}/doc-fields/`,
  CLAUSES: `${BASEPATH}/clauses/`,
  CLONE_GLOBAL_TEMPLATE: `${BASEPATH}/global_template/clone`,
  COMPONENTS_RESTORE: `${BASEPATH}/doc-components-restore`, // Used in case of delete undo
  COMPONENTS: `${BASEPATH}/doc-components`,
  CONVERT_FORMDOC_TO_EDITOR: `${BASEPATH}/docs/type`,
  CREATE_NEW_DOCUMENT_FROM_GLOBAL_TEMPLATE: `${BASEPATH}/docs/global_template`,
  CREATE_NEW_DOCUMENT: `${BASEPATH}/docs`,
  CREATE_ORG_v2: `${BASEPATH}/v2/orgs`,
  CREATE_ORG: `${BASEPATH}/orgs`,
  CRM_CALLBACK: `${BASEPATH}/crm/authenticate`,
  CRM_CONFIG: `${BASEPATH}/crm_config`,
  CRM_OAUTH_USERS: `${BASEPATH}/crm/oauth/users`,
  CRM_OAUTH: `${BASEPATH}/crm/oauth/authenticate`,
  CRM_SYNC: `${BASEPATH}/crm/sync`,
  CRM_USER_CALLBACK: `${BASEPATH}/crm/user_auth/callback`,
  CRM_USER_CONFIGS: `${BASEPATH}/crm_user_configs`,
  CRM_USER: `${BASEPATH}/crm_user_config`,
  CRM: `${BASEPATH}/crm_configs`,
  DASHBOARD: `${BASEPATH}/dashboard`,
  DATASTUDIO_TRIGGER: `${BASEPATH}/datastudio/event_trigger`,
  DEALS: `${BASEPATH}/deals`,
  DEALTABLES: `${BASEPATH}/deal-tables`,
  DELETE_DOCUMENT_TEMPLATE: `${BASEPATH}/docstemplate`,
  DISSCONNECT_DOCU_SIGN: `${BASEPATH}/docusign/disconnect`,
  DOC_AS_TEMPLATE: `${BASEPATH}/documents`,
  DOC_ATTACHMENTS: `${BASEPATH}/attachments`,
  DOC_DEALS: `${BASEPATH}/doc-deals`,
  DOC_ENTITIES: `${BASEPATH}/docs/entities`,
  DOC_FIELDS_TYPES: `${BASEPATH}/doc-field-types`,
  DOC_FIELDS: `${BASEPATH}/doc-fields/`,
  DOC_PREVIEW: `${BASEPATH}/docs/preview`,
  DOC_REVVAI_METADATA_BULK: `${BASEPATH}/revvai/metadata/bulk-download`,
  DOC_REVVAI_METADATA: `${BASEPATH}/revvai/docs`,
  DOC_SETTINGS: `${BASEPATH}/doc-settings`,
  DOC_SIGN: `https://account-d.docusign.com/oauth/auth?response_type=code`,
  DOC_SIGNATORIES_V2: `${BASEPATH}/v2/doc-signatories/`,
  DOC_SIGNATORY: `${BASEPATH}/doc-signatories`,
  DOC_SIGNER_IDS: `${BASEPATH}/doc-signer-identities/`,
  DOC_STAGE: `${BASEPATH}/docs/stage`,
  DOC_STATUS: `${BASEPATH}/docs/status`,
  DOC_TAG: `${BASEPATH}/docs/tag`,
  DOC_TEMPLATE_SIGNATORY: `${BASEPATH}/doc-templates/signatories/`,
  DOC_TYPES: `${BASEPATH}/doctypes`,
  DOCS_ACCEPTORS: `${BASEPATH}/v2/doc-acceptors`,
  DOCS_BULK_CREATE: `${BASEPATH}/docs/bulk-create/`,
  DOCS_CONTENT: `${BASEPATH}/docs_content`,
  DOCS_CSV_TEMPLATE: `${BASEPATH}/docs/csv-template/`,
  DOCS_RECIPIENTS_V2: `${BASEPATH}/v2/doc-recipients`,
  DOCS_RECIPIENTS: `${BASEPATH}/doc-recipients`,
  DOCS: `${BASEPATH}/docs`,
  DOCUMENT_CLAUSE: `${BASEPATH}/clauses/`,
  DOCUMENT_TEMPLATES: `${BASEPATH}/docstemplate/`,
  DOCUMENTS_V2: `${BASEPATH}/v2/documents`,
  DOCUMENTS: `${BASEPATH}/documents`,
  DP_MAPPING: `${BASEPATH}/datastudio/mapping`,
  DP_OBJECT_FIELDS: `${BASEPATH}/crm/object_fields`,
  DP_OBJECTS: `${BASEPATH}/crm/objects`,
  ECOMM_PERMALINK: `${BASEPATH}/docstemplate1/ecomm/publish`,
  EMAIL_PREFERENCES: `${BASEPATH}/organizations/notifications/configuration`,
  EDIT_DOCUMENT: `${BASEPATH}/docs/revision/edit`,
  ESIGNATURE: `${BASEPATH}/esign/signature`,
  EVENTS_AGGREGATE: `${BASEPATH}/events/aggregate`,
  EVENTS_DIGITAL_TRANSATION: `${BASEPATH}/events/digital-transactions`,
  EVENTS: `${BASEPATH}/events`,
  EXPORT_DOCX: `${BASEPATH}/docs/export`,
  EXPORT_FILLED_PDF: `${BASEPATH}/docs/download-pdf`,
  FETCH_CRM_OBJECTS: `${BASEPATH}/crm/objects`,
  FETCH_DOC_SIGN_PDF: `${BASEPATH}/docs`,
  FETCH_FIELDS_LIST: `${BASEPATH}/datastudio/fields`,
  FETCH_ORG_FIELDS_MAPPING: `${BASEPATH}/datastudio/org_mapping`,
  FETCH_TEMPLATE_FIELDS_MAPPING: `${BASEPATH}/datastudio/template_mapping`,
  GET_DOC_ID: `${BASEPATH}/docs`,
  GET_DOCTYPE_ID: `${BASEPATH}/docs/id`,
  GET_NOTIFICATIONS: `${BASEPATH}/notifications`,
  GET_QUOTE_ID: `${BASEPATH}/quoteid`,
  GET_REDIRECT_URL: `${BASEPATH}/docusign/connect`,
  GLOBAL_TEMPLATES_DEMO: `${BASEPATH}/demo/global_templates`,
  GLOBAL_TEMPLATES: `${BASEPATH}/global_template`,
  GOOGLE_SHEET_AUTH: `${BASEPATH}/google_auth/`,
  GOOGLE_SHEET_DATA: `${BASEPATH}/google/`,
  GROUPS: `${BASEPATH}/groups`,
  IMAGE_UPLOAD: `${BASEPATH}/images`,
  JTBDS: `${BASEPATH}/jtbds`,
  LANE_JTBDS: `${BASEPATH}/lane-jtbds`,
  LEGALLY_BINDED_SIGNATORY: `${BASEPATH}/esign/count`,
  MASTER_DOC_LINK: `${BASEPATH}/master-link`,
  MASTER_DOC: `${BASEPATH}/master/DOC`,
  MASTER: `${BASEPATH}/master`,
  // Change path acc to BE changes
  META_FIELDS: `${BASEPATH}/metagroups`,
  NOTES: `${BASEPATH}/comments`,
  OAUTH_CONSENT: `${PUBLIC_BASEPATH}/auth/clients/authorize`,
  OPPORTUNITIES_V2: `${BASEPATH}/v2/opportunities`,
  OPPORTUNITIES_V3: `${BASEPATH}/v3/opportunities`,
  OPPORTUNITIES: `${BASEPATH}/opportunities`,
  OPPORTUNITY_STAGES: `${BASEPATH}/oppstages`,
  ORGS_METERS: `${BASEPATH}/orgs/meters`,
  ORGS: `${BASEPATH}/organizations`,
  PDF_FORM_FIELDS: `${BASEPATH}/docs/pdf-fields`,
  PDF_TEMPLATE_FORM_FIELDS: `${BASEPATH}/doc_template/pdf-fields`,
  PDF: `${PYTHON_BASEPATH}/quotepdf`,
  PERMA_DOC: `${BASEPATH}/perma/DOC`,
  PERMA_LINK: `${BASEPATH}/perma-link`,
  PING: `${BASEPATH}/ping`,
  PIPELINE: `${BASEPATH}/pipeline`,
  PIPELINES: `${BASEPATH}/pipelines`,
  PRICE_LISTS: `${BASEPATH}/pricelists`,
  PRODUCT_FAMILIES: `${BASEPATH}/product_families`,
  PRODUCTS: `${BASEPATH}/products`,
  QUOTE_DOCUMENT: `${BASEPATH}/quotes`,
  QUOTES: `${BASEPATH}/quotes`,
  QUOTETERM_TEMPLATES: `${BASEPATH}/quotetemplate`,
  RBAC: `${BASEPATH}/rbac`,
  REFERRAL: `${BASEPATH}/organizations/referral`,
  REMINDER_EVENTS: `${BASEPATH}/reminder-events`,
  REMINDER_SETTINGS_PIPELINE: `${BASEPATH}/reminder-settings/pipeline/`,
  REVV_OAUTH_CLIENT: `${BASEPATH}/clients/`,
  REVV_OAUTH: `${BASEPATH}/applications/`,
  SIGNATURE_SETTING: `${BASEPATH}/esign-settings`,
  SAML_SETTINGS: `${BASEPATH}/saml2/settings`,
  SAML_USER_TOKEN: `${BASEPATH}/saml2/token`,
  SAML: `${BASEPATH}/saml2/acs`,
  SEND_DOC_TO_DOCU_SIGN: `${BASEPATH}/docusign/upload-pdf`,
  SF_LOGIN_OAUTH2: `https://login.salesforce.com/services/oauth2/authorize`,
  SF_SAML_AUTH_REQUEST: `${BASEPATH}/saml2/authrequest`,
  SF_TEST_OAUTH2: `https://test.salesforce.com/services/oauth2/authorize`,
  SHARE_DOCUMENT_ATTACHMENT: `${BASEPATH}/shared/attachments`,
  SHARE_DOCUMENT: `${BASEPATH}/sharing/docs`,
  SHARED_DOCUMENTS_V2: `${BASEPATH}/v2/shared/documents`,
  SHARED_DOCUMENTS: `${BASEPATH}/shared/documents`,
  SHARED_REVVAI_METADATA: `${BASEPATH}/revvai/shared`,
  SIGNING_DOCUMENTS: `${BASEPATH}/signing-documents`,
  SNAP_LINK: `${BASEPATH}/snap-link`,
  START_FIELD_SYNC: `${BASEPATH}/datastudio/sync`,
  STRIPE_AUTH: `${BASEPATH}/stripe`,
  STRIPE_TRANSACTION_CHECKOUT: `${BASEPATH}/stripe/transactions`,
  STRIPE_BILLING_CHECKOUT: `${BASEPATH}/stripe/billing/checkout`,
  STRIPE_BILLING_PAYMENT: `${BASEPATH}/stripe/billing/lastpayment`,
  STRIPE_BILLING_PORTAL: `${BASEPATH}/stripe/billing/portal`,
  SUPPORT_EMAIL: `${BASEPATH}/support/email`,
  SYNC_DOC_SIGN: `${BASEPATH}/docusign/credentials`,
  TABLES: `${BASEPATH}/tables`,
  TABLE_FIELDS: `${BASEPATH}/table-fields`,
  TEMP_REVVAI_SUGGEST_FIELDS: `${BASEPATH}/revvai/templates/fields/suggest`,
  TEMPLATE_COMPONENT_RESTORE: `${BASEPATH}/template-components-restore`,
  TEMPLATE_COMPONENTS: `${BASEPATH}/template-components`,
  TEMPLATE_RECIPIENT_TYPE: `${BASEPATH}/templates/recipient-type/`,
  TEMPLATE_SEARCH_CONTENT: `${BASEPATH}/template/search`,
  TEMPLATE_SEARCH_SUGGESTIONS: `${BASEPATH}/template/suggestions`,
  TEMPLATE_SIGNATORY_V2: `${BASEPATH}/v2/template-signatories/`,
  TEMPLATE_SIGNATORY: `${BASEPATH}/template-signatories`,
  TEMPLATE_SIGNER_IDENTITIES: `${BASEPATH}/template-signer-identities/`,
  TEMPLATE_TAG: `${BASEPATH}/docstemplatetag`,
  TEMPLATE_V2: `${BASEPATH}/v2/templates`,
  TEMPLATES_JSON: `${BASEPATH}/templates`,
  TEMPLATES_PUBLISH: `${BASEPATH}/templates/publish`,
  TEMPLATES: `${BASEPATH}/v1/templates`,
  TOGGLE_DOCUMENT_TEMPLATE: `${BASEPATH}/template-toggle`,
  UNSPLASH_BASEURL: `https://api.unsplash.com/search/photos`,
  UNUSED_PRODUCTS: `${BASEPATH}/unused_products`,
  UPDATE_DOC_COMPONENT_BATCH: `${BASEPATH}/doc-components-batch`,
  UPDATE_DOC_FIELD_NON_LOGGED_IN: `${BASEPATH}/shared/documents`,
  UPDATE_DOC_FIELD: `${BASEPATH}/doc`,
  UPDATE_DOC_SIGNATORY: `${BASEPATH}/doc-signatories`,
  UPLOAD_DOCUMENT: `${BASEPATH}/docs/upload`,
  UPLOAD_PDF_TEMPLATE: `${BASEPATH}/pdf-template/upload`,
  UPLOAD_PDF: `${BASEPATH}/pdf/upload`,
  UPLOAD_QUOTE_DOCUMENT: `${BASEPATH}/docs/convert`,
  UPLOAD_REVISED_DOCUMENT: `${BASEPATH}/docs/revision`,
  UPLOAD_SAML_CERTIFICATE: `${BASEPATH}/saml2/certificate`,
  USER_FEATURES: `${BASEPATH}/user-features`,
  USER_GROUPS: `${BASEPATH}/usergroups`,
  USERPROFILE: `${BASEPATH}/userprofile`,
  USERS_V2: `${BASEPATH}/v2/users`,
  USERS: `${BASEPATH}/users`,
  VIEW_METADATA: `${BASEPATH}/meta`,
  VIEWS: `${BASEPATH}/views`,
  WORK_FLOW_CONDITIONS: `${BASEPATH}/conditions-meta`,
  WORK_FLOW_EVENT: `${BASEPATH}/wf-event`,
  WORK_FLOW_RULES: `${BASEPATH}/wfrules`,
  WORK_FLOW_TRIGGER: `${BASEPATH}/wf-trigger`,
  WORK_FLOW: `${BASEPATH}/wf`,
  ZAPIER_KEY_BASED_ON_ORG: `${BASEPATH}/zapier/api-key`,
  ZAPIER_KEY: `${BASEPATH}/api-key`,
  ZH_OAUTH2: `https://accounts.zoho.com/oauth/v2/auth?scope=ZohoCRM.users.ALL,ZohoCRM.modules.ALL,ZohoCRM.settings.ALL`,
  FETCH_SSR_DOC_SIGN_PDF: `${BASEPATH}/v2/docs/export`,
  FETCH_SSR_TEMPLATE_PDF: `${BASEPATH}/v2/templates/export`,
  BLOCKCHAIN_SETTINGS_CONSENT: `${BASEPATH}/blockchain/settings`,
  BLOCKCHAIN_DOC_HASHES: `${BASEPATH}/blockchain/documents`,
  DOC_TEMPLATE_CONDITIONAL: `${BASEPATH}/docstemplate/conditional-logic`,
  CLIENT_CREDENTIALS: `${BASEPATH}/client-credentials`,
  APPLICATIONS: `${BASEPATH}/applications`,
  SHARED_DOCUMENTS_RV: `${BASEPATH}/shared/documents`,
  SHARED_DOCUMENTS_LZ: `${BASEPATH}/lz/shared/documents`,
  SIGNING_DOCUMENTS_RV: `${BASEPATH}/signing-documents`,
  SIGNING_DOCUMENTS_LZ: `${BASEPATH}/lz/signing-documents`,
};

// eslint-disable-next-line import/prefer-default-export
export { APIS };
